import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { addBasketItem } from 'store/basket/basketSlice';
import { ApplicationState } from 'store/store';
import { IProduct, ISuggestions } from '../model/Menu';
import { MenuSuggestionsBogof } from './MenuSuggestionsBogof';

export const useBogofModal = (onClose: () => void, quantity: number, modifiers?: boolean) => {
    const dispatch = useAppDispatch();
    const { menu } = useSelector((state: ApplicationState) => state.menu);
    const currency = useSelector(
        (state: ApplicationState) => state.settings.settings?.region?.currencyCode ?? 'GBP'
    );
    const [suggestionBogof, setBogofSuggestion] = React.useState<ISuggestions | null>(null);
    const [product, setProduct] = React.useState<IProduct | null>(null);
    const [newQuantity, setNewQuantity] = React.useState<number | null>(null);

    const handleSuggestionsClose = React.useCallback(() => {
        setBogofSuggestion(null);
    }, []);

    const handleChangeQuantity = React.useCallback(
        (changedQuantity: number) => {
            if (modifiers) {
                setNewQuantity(changedQuantity);
                return;
            }
            if (menu && product) {
                setBogofSuggestion(null);

                const categoryId = menu.productIdToCategoryId.get(product.id);
                dispatch(addBasketItem(product, categoryId || '', changedQuantity, undefined, product.price));
                onClose();
            }
        },
        [dispatch, menu, modifiers, onClose, product]
    );

    const bogofModal = React.useCallback(() => {
        if (suggestionBogof) {
            return (
                <MenuSuggestionsBogof
                    open={!!suggestionBogof}
                    onClose={handleSuggestionsClose}
                    changeQuantity={handleChangeQuantity}
                    currency={currency}
                    suggestion={suggestionBogof}
                    quantity={quantity}
                />
            );
        }
        return null;
    }, [currency, handleChangeQuantity, handleSuggestionsClose, quantity, suggestionBogof]);

    return { bogofModal, setBogofSuggestion, setProduct, newQuantity, setNewQuantity };
};
